import { FC } from 'react';
import { Box, BoxProps, Typography } from '@mui/material';
import { CountryIcon, getCountryCode } from '@monorepo/nova-icons';

type Props = BoxProps<'li'> & {
  option: { value: string; text: string };
  optionProps?: React.HTMLAttributes<HTMLLIElement>;
};

export const FlagOption: FC<Props> = ({ option, optionProps }) => {
  return (
    <Box
      component="li"
      sx={{ '& > svg': { mr: 3, flexShrink: 0 } }}
      {...optionProps}
    >
      <CountryIcon code={getCountryCode(option.value) || 'UN'} />
      <Typography>{option.text}</Typography>
    </Box>
  );
};
